import { CUSTOMER_JOURNEY_LOGIN_RESERVATION_SUCCESS } from '../const';

function action(data, successCallback) {
  return { type: CUSTOMER_JOURNEY_LOGIN_RESERVATION_SUCCESS, data, successCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyLoginReservationSuccess.js